import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import * as Sentry from '@sentry/react'
import { Link, useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { useReactToPrint } from 'react-to-print'

import { Button, IconButton, Loader } from '../../components/transpais'
import Ticket from '../../components/transpais/TranspaisTicket'
import {
  BASE_URL,
  DEBUG_PINPAD,
  IDLE_DONE_TIMEOUT_SECONDS,
  KIOSK_CONFIRMED_IDLE_DONE_EVENT,
  VER_APP,
} from '../../utilities/constants'
//import logo_cpagos_image from '../../assets/images/logo_cpagos.png'

import {
  accessToken,
  estacionID,
  puntoVentaID,
  reservationConfirmation,
  reservationFolio,
  pinpadPayment,
  reservationTickets,
  usuarioID,
  bookingSessionTickets,
  bookingSessionPayments,
  idleDoneTimerPaused,
  idleTimerPaused,

} from '../../utilities/atoms'
import { useModal } from '../../contexts/modal.context'
import { useTimer } from '../../contexts/timer.context'

import gateway from '../../services/gateway'

import '../../scss/Layout.scss'
import global from './BookingGlobal.module.scss'
import styles from './BookingConfirmed.module.scss'
import { Helmet } from 'react-helmet'
import { genericErrorMessage } from '../../utilities/alerts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useLogger } from '../../contexts/logger.context'
import { Breadcrumbs } from '@sentry/react'
import { currency } from '../../components/transpais/helpers/currency'
import SaleTicket from './SaleTicket'
import { serializeElementForNativePrint, tryNativeVoucherPrint } from '../../utilities/voucherNativePrint'
import { recordFlightEvent } from '../../debug/flightRecorder'

const BookingConfirmed = () => {

  const {loggerDebug} = useLogger()
  const navigate = useNavigate()

  const printAll = useRef(false)
  const ticketsArea = useRef(null)
  const selectedTicket = useRef(null)
  const ticketsRefs = useRef([])

  //const [modalType, setModalType] = useState(null)
  //const [modalPositiveTitle, setModalPositiveTitle] = useState('Si')
  //const [modalNegativeTitle, setModalNegativeTitle] = useState('No')
  //const [modalContent, setModalContent] = useState(null)
  //const [selectedTicket, setSelectedTicket] = useState(null)
  const [idleDonePaused, setIdleDonePaused] = useAtom(idleDoneTimerPaused)
  const [, setIdlePaused] = useAtom(idleTimerPaused)

  const [wasPrinted, setWasPrinted] = useState(false)

  const [currentTicketsScroll, setCurrentTicketsScroll] = useState(0)
  const [showScrollBottom, setShowScrollBottom] = useState(false)
  const [showScrollTop, setShowScrollTop] = useState(false)

  // Todos los atoms para reset
  const [bookingTickets, setBookingTickets] = useAtom(bookingSessionTickets)
  const [bookingPayments, setBookingPayments] = useAtom(bookingSessionPayments)
  const [payment, setPayment] = useAtom(pinpadPayment)
  const {showTimer, hideTimer, setupTimer} = useTimer()

  // Pinpad web context está obsoleto; el pago aprobado vive en el atom `pinpadPayment`.
  const {showModal, hideModal, setupModal} = useModal()
  const componentRef = useRef(null);
  const [voucherPrint, setVoucherPrint] = useState(false)
  const [voucherPrinted, setVoucherPrinted] = useState(false)
  const voucherPrintStartedRef = useRef(false)
  const voucherHtmlLoggedRef = useRef(false)

  // DEBUG ONLY (legacy): voucher hardcodeado.
  // Ya no se utiliza con el flujo actual de pago vía Electron.
  // const dataCharge = { ... }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current, // Aquí pasamos la referencia al componente que queremos imprimir
    onBeforePrint: () => {
      recordFlightEvent('PRINT:DIALOG_BEFORE', { kind: 'voucher' }, 'BookingConfirmed.handlePrint')
      console.log('Antes de imprimir');
    },
    onAfterPrint: () => {
      recordFlightEvent('PRINT:DIALOG_AFTER', { kind: 'voucher' }, 'BookingConfirmed.handlePrint')
      console.log('Después de imprimir');
      setVoucherPrinted(true)
    },
    onPrintError: (errorLocation, error) => {
      recordFlightEvent('PRINT:DIALOG_ERROR', {
        kind: 'voucher',
        location: errorLocation,
        message: error instanceof Error ? error.message : String(error),
      }, 'BookingConfirmed.handlePrint')
      console.error('Error de impresión:', error)
    },
  })

  const processFormat = (text) => {
    const safeText = typeof text === 'string' ? text : ''
    if (!safeText) return null

    // Normalizar saltos: solo \r (sin \n) es común vía bridge/DLL; si no se unifica, todo queda en UNA línea y
    // solo el primer @ se interpreta — el resto (@cnn, @br, @lnn…) se imprime crudo.
    const lines = safeText.replace(/\uFEFF/g, '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n')

    const mapAlign = (c) => (c === 'l' ? 'left' : c === 'c' ? 'center' : c === 'r' ? 'right' : 'left')
    // Valores en px: 'normal'/'small'/'big' no son válidos en CSS font-size y el motor los ignora → voucher “plano”.
    const mapSize = (c) => (c === 's' ? '8px' : c === 'n' ? '9px' : c === 'b' ? '11px' : '9px')
    const mapWeight = (c) => (c === 'b' ? 'bold' : c === 'l' ? '300' : 'normal')

    return lines.map((rawLine, index) => {
      const line0 = String(rawLine ?? '').replace(/\r/g, '')
      // Si hay espacios/BOM antes del comando, el startsWith('@') falla y se imprime crudo.
      const line = line0.replace(/^\uFEFF/, '').trimStart()

      if (line.startsWith('@')) {
        // Manejo explícito de @br (salto de línea)
        if (line.startsWith('@br')) {
          return <br key={index} />
        }

        const alignment = mapAlign(line[1])
        const cmd = line.slice(0, 4)
        // Subir tamaño del pagaré (@lsn) para mejorar legibilidad y ocupar el ancho.
        const fontSize = cmd === '@lsn' ? '10px' : mapSize(line[2])
        const fontWeight = mapWeight(line[3])

        const payload = line.slice(4).trimStart()

        if (payload.includes('logo_cpagos')) {
          return (
            <img
              key={index}
              src="data:image/png;base64,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"
              alt="Logo CPagos"
              style={{
                display: 'block',
                margin: '0 auto', // centrar horizontalmente
                marginTop: '10px',
                width: '180px',
                height: '35px',
              }}
            />
          )
        }
        if (payload.includes('ver_app')) {
          return (
            <p key={index} style={{ textAlign: alignment, fontSize, fontWeight, color: '#c62828' }}>
              {VER_APP}
            </p>
          )
        }
        return (
          <p key={index} style={{ textAlign: alignment, fontSize, fontWeight }}>
            {payload}
          </p>
        )
      } else {
        return (
          <p key={index} style={{ textAlign: 'left', fontSize: '9px', fontWeight: 'normal' }}>
            {line0}
          </p>
        );
      }
    });
  };


  const exit = useCallback(() => {
    hideTimer()
    hideModal()
    setBookingTickets([])
    setPayment({})
    setBookingPayments({})
    setIdleDonePaused(true)

    navigate(`${ BASE_URL }/`)
  }, [hideTimer, hideModal, navigate, setBookingTickets, setPayment, setBookingPayments, setIdleDonePaused])

  const exitRef = useRef(exit)
  exitRef.current = exit

  const printDone = () => {
    loggerDebug('Printing completed...', printAll, selectedTicket.current, ticketsRefs.current.length)
    if (printAll.current && selectedTicket.current < (ticketsRefs.current.length - 1)) {
      selectedTicket.current++
      recordFlightEvent('PRINT:TICKET_CHAIN_NEXT', {
        index: selectedTicket.current,
        total: ticketsRefs.current.length,
      }, 'BookingConfirmed.printDone')
      ticketsRefs.current[selectedTicket.current].printTicket()
    } else {
      selectedTicket.current = 0
      printAll.current = false
      recordFlightEvent('PRINT:TICKET_CHAIN_DONE', { total: ticketsRefs.current.length }, 'BookingConfirmed.printDone')
      setWasPrinted(true)
    }
  }

  const askPrintAll = () => {
    setupModal({
      title: 'Imprimir',
      content: <p>Estás a punto de imprimir todos tus boletos, toma cada uno conforme vaya saliendo ¿deseas continuar
        con la impresión?</p>,
      actions: {
        positive: {
          title: 'Si',
          onClick: () => {
            printAll.current = true
            selectedTicket.current = 0
            ticketsRefs.current[selectedTicket.current].printTicket()
            hideModal()
          }
        },
        negative: {
          title: 'No',
          onClick: () => {
            //selectedTicket.current = null
            hideModal()
          }
        }
      }
    })
    showModal()
  }

  const askPrint = () => {
    setupModal({
      title: 'Imprimir',
      content: <p>Al parecer ya imprimiste este boleto, ¿deseas imprimirlo una vez más?</p>,
      actions: {
        positive: {
          title: 'Reimprimir',
          onClick: () => {
            //loggerDebug(ticketsRefs.current,selectedTicket.current,ticketsRefs.current[selectedTicket])
            console.log(ticketsRefs.current[selectedTicket.current])
            console.log(ticketsRefs.current)
            console.log(selectedTicket.current)
            ticketsRefs.current[selectedTicket.current].printTicket()
            selectedTicket.current = null
            hideModal()
          }
        },
        negative: {
          title: 'No',
          onClick: () => {
            selectedTicket.current = null
            hideModal()
          }
        }
      }
    })
    showModal()
  }

  const askExit = () => {
    setupModal({
      title: 'Atención',
      content: <p>No imprimiste tus boletos, puedes verlos en tu app Transpais, ¿deseas volver al inicio?</p>,
      styles: {
        buttonType: 'small',
      },
      actions: {
        positive: {
          title: 'Quedarme a imprimirlos',
          onClick: () => {
            hideModal()
          }
        },
        negative: {
          title: 'Volver al inicio sin imprimirlos',
          onClick: () => {
            hideModal()
            exit()
          }
        }
      }
    })
    showModal()
  }

  const voucher = () => {
    const voucherText = payment?.voucher_cliente || ''
    return (
      <div ref={componentRef} className={ styles.voucherContainer }>
        {processFormat(voucherText)}
      </div>
    )
  }

  useEffect(() => {
    if ( !voucherPrinted ) {
      setVoucherPrint(true)
    } else if (!printAll.current) {
      printAll.current = true
      selectedTicket.current = 0
      recordFlightEvent('PRINT:CONFIRMED_START_TICKETS', {
        count: ticketsRefs.current.length,
      }, 'BookingConfirmed.useEffect[voucherPrinted]')
      ticketsRefs.current[selectedTicket.current].printTicket()
    }
  }, [voucherPrinted, voucherPrint])

  useLayoutEffect(() => {
    if (!voucherPrint || voucherPrinted) return

    const voucherText = payment?.voucher_cliente
    if (!voucherText || !String(voucherText).trim()) return

    recordFlightEvent('PRINT:VOUCHER_EFFECT_START', {
      voucherLen: String(voucherText).length,
    }, 'BookingConfirmed.useLayoutEffect[voucher]')

    let cancelled = false

    const isDomReady = () => {
      const el = componentRef.current
      const textLen = el?.textContent?.trim()?.length ?? 0
      const innerLen = el?.innerHTML?.trim()?.length ?? 0
      const ready = !!(el && (textLen > 0 || innerLen > 0))
      return { el, textLen, innerLen, ready }
    }

    const runVoucherPrint = () => {
      // Guard: evita doble impresión/doble diálogo por callbacks diferidos.
      if (voucherPrintStartedRef.current) {
        recordFlightEvent('PRINT:VOUCHER_SKIP', { reason: 'already_started' }, 'BookingConfirmed.runVoucherPrint')
        return
      }
      voucherPrintStartedRef.current = true
      cancelled = true

      void (async () => {
        recordFlightEvent('PRINT:VOUCHER_NATIVE_FLOW', { phase: 'start' }, 'BookingConfirmed.runVoucherPrint')
        const elNow = componentRef.current
        if (!elNow || !String(elNow.innerHTML || '').trim()) {
          recordFlightEvent('PRINT:VOUCHER_DOM_EMPTY', {}, 'BookingConfirmed.runVoucherPrint')
          console.error('[VOUCHER] DOM vacío: no se puede imprimir sin diálogo')
          return
        }

        const serialized = await serializeElementForNativePrint(elNow, {
          baseHref: typeof window !== 'undefined' ? window.location.href : '',
        })
        if (!serialized.ok) {
          recordFlightEvent('PRINT:VOUCHER_SERIALIZE_FAIL', { ok: serialized?.ok, code: serialized?.code }, 'BookingConfirmed.runVoucherPrint')
          console.error('[VOUCHER] serialize failed', serialized)
          return
        }
        if (serialized.debug) {
          console.log('[VOUCHER][ASSETS]', serialized.debug)
        }

        let htmlToPrint = serialized.html
        const hasImgTag = typeof htmlToPrint === 'string' && htmlToPrint.toLowerCase().includes('<img')
        console.log('[VOUCHER][HTML_CHECK]', { hasImgTag, htmlLength: String(htmlToPrint || '').length })

        // Fix: si el voucher trae logo_cpagos pero el HTML no contiene <img>, inyectar logo por IPC (base64).
        if (!hasImgTag && String(payment?.voucher_cliente || '').includes('logo_cpagos')) {
          try {
            const r =
              typeof window !== 'undefined' &&
              window.electronAPI &&
              typeof window.electronAPI.getLogoCpagosDataUrl === 'function'
                ? await window.electronAPI.getLogoCpagosDataUrl()
                : null
            if (r && r.ok === true && r.dataUrl) {
              htmlToPrint += `
                <div style="text-align:center;margin-top:10px;">
                  <img src="${String(r.dataUrl)}" alt="Logo CPagos" style="width:180px;height:35px;display:inline-block;" />
                </div>
              `
              console.log('[VOUCHER][LOGO_INJECTED]', { file: r.file || null })
            } else {
              console.warn('[VOUCHER][LOGO_INJECT_FAILED]', r)
            }
          } catch (e) {
            console.warn('[VOUCHER][LOGO_INJECT_THROW]', e instanceof Error ? e.message : String(e))
          }
        }

        if (!voucherHtmlLoggedRef.current) {
          voucherHtmlLoggedRef.current = true
          // Log completo (puede ser largo). Si molesta, cambiar a slice(0, N).
          console.log('[VOUCHER][HTML_FINAL]', htmlToPrint)
        }

        recordFlightEvent('PRINT:VOUCHER_IPC_CALL', {
          htmlLen: typeof htmlToPrint === 'string' ? htmlToPrint.length : 0,
        }, 'BookingConfirmed.runVoucherPrint')

        const native = await tryNativeVoucherPrint(htmlToPrint, {
          baseHref: typeof window !== 'undefined' ? window.location.href : '',
        })

        if (native.ok) {
          recordFlightEvent('PRINT:VOUCHER_NATIVE_OK', {}, 'BookingConfirmed.runVoucherPrint')
          console.log('[VOUCHER] impresión nativa Electron OK')
          setVoucherPrinted(true)
          return
        }

        // Modo kiosko sin diálogo: NO caer a react-to-print. Se bloquea la cadena y se ofrece reintento nativo.
        recordFlightEvent('PRINT:VOUCHER_NATIVE_FAIL', {
          code: native?.code,
          message: native?.message,
        }, 'BookingConfirmed.runVoucherPrint')
        console.error('[VOUCHER] impresión nativa falló (sin fallback a diálogo)', native)
        try {
          if (window.electronAPI?.getPrintConfig) {
            const printCfg = await window.electronAPI.getPrintConfig()
            console.log('[VOUCHER][CONFIG_INI]', {
              path: printCfg?.configIniPath,
              exists: printCfg?.configIniExists,
              printerFromIni: printCfg?.configIniPrinter,
              content: printCfg?.configIniContent,
              resolvedPrinter: printCfg?.printerName,
              source: printCfg?.printerSource,
            })
          }
        } catch (cfgErr) {
          console.warn('[VOUCHER][CONFIG_INI] no se pudo leer', cfgErr)
        }
        recordFlightEvent('PRINT:VOUCHER_RETRY_MODAL', { code: native?.code }, 'BookingConfirmed.runVoucherPrint')
        const printerLabel =
          typeof native?.deviceName === 'string' && native.deviceName.trim()
            ? native.deviceName.trim()
            : 'no se encontró impresora'
        setupModal({
          title: 'Impresión',
          content: (
            <>
              <p>No se pudo imprimir el voucher en modo automático.</p>
              <p>Revisa impresora {printerLabel} y configuración del kiosko, luego reintenta.</p>
            </>
          ),
          actions: {
            positive: {
              title: 'Reintentar',
              onClick: () => {
                recordFlightEvent('PRINT:VOUCHER_RETRY_CLICK', {}, 'BookingConfirmed.retryModal')
                hideModal()
                voucherPrintStartedRef.current = false
                // Reintenta una vez más al siguiente tick de UI.
                setTimeout(() => {
                  runVoucherPrint()
                }, 0)
              },
            },
            negative: {
              title: 'Cancelar',
              onClick: () => {
                recordFlightEvent('PRINT:VOUCHER_RETRY_CANCEL', {}, 'BookingConfirmed.retryModal')
                hideModal()
              },
            },
          },
        })
        showModal()
      })()
    }

    const tryPrint = (phase) => {
      if (cancelled) return

      const { el, textLen, innerLen, ready } = isDomReady()

      console.log('[VOUCHER DEBUG]', {
        phase,
        hasRef: !!el,
        textLength: textLen,
        innerLength: innerLen,
        voucherLength: String(voucherText).length,
      })

      if (ready) {
        runVoucherPrint()
        return
      }

      if (phase === 'afterDoubleRaf') {
        requestAnimationFrame(() => {
          if (cancelled) return
          tryPrint('afterTripleRaf')
        })
        return
      }

      if (phase === 'afterTripleRaf') {
        setTimeout(() => {
          if (cancelled) return
          const { el: el2, ready: ready2 } = isDomReady()
          console.log('[VOUCHER DEBUG]', { phase: 'afterTimeout0', hasRef: !!el2, ready: ready2 })
          if (ready2) {
            runVoucherPrint()
          } else {
            recordFlightEvent('PRINT:VOUCHER_CHAIN_UNLOCK_NO_DOM', { phase: 'afterTimeout0' }, 'BookingConfirmed.tryPrint')
            console.warn('[VOUCHER DEBUG] DOM sin texto tras defer; se desbloquea cadena de tickets')
            setVoucherPrinted(true)
          }
        }, 0)
      }
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (cancelled) return
        tryPrint('afterDoubleRaf')
      })
    })

    return () => {
      cancelled = true
    }
  }, [voucherPrint, voucherPrinted, payment?.voucher_cliente, handlePrint])

  useEffect(() => {
    loggerDebug(ticketsArea.current.scrollTop)
    loggerDebug(ticketsArea.current.offsetHeight)
    loggerDebug(ticketsArea.current.scrollHeight)
    if (ticketsArea.current.scrollHeight > ticketsArea.current.offsetHeight) {
      setShowScrollBottom(true)
    }
  }, [ticketsArea])

  const handleScroll = (e) => {
    setCurrentTicketsScroll(ticketsArea.current.scrollTop)
  }

  useEffect(() => {
    //loggerDebug(ticketsArea.current.scrollTop)
    //loggerDebug(ticketsArea.current.offsetHeight)
    //loggerDebug(ticketsArea.current.scrollHeight)
    if (currentTicketsScroll > 0) {
      setShowScrollTop(true)
    } else {
      setShowScrollTop(false)
    }

    if ((ticketsArea.current.scrollTop + ticketsArea.current.offsetHeight) === ticketsArea.current.scrollHeight) {
      setShowScrollBottom(false)
    } else {
      setShowScrollBottom(true)
    }
  }, [currentTicketsScroll])

  useEffect(() => {
    const onIdleDone = () => exitRef.current()
    window.addEventListener(KIOSK_CONFIRMED_IDLE_DONE_EVENT, onIdleDone)
    return () => window.removeEventListener(KIOSK_CONFIRMED_IDLE_DONE_EVENT, onIdleDone)
  }, [])

  useEffect(() => {
    setIdleDonePaused(false)
    const reinforceDoneMode = () => setIdlePaused(true)
    reinforceDoneMode()
    const syncT = setTimeout(reinforceDoneMode, 0)
    const doneMs = IDLE_DONE_TIMEOUT_SECONDS * 1000
    const deadline = new Date(Date.now() + doneMs).toISOString()
    // Solo HUD visual; regreso real: idleDoneTimer → App.onDoneIdle → evento → exit().
    setupTimer(deadline, () => {
      recordFlightEvent('IDLE:CONFIRMED_UI_ZERO', {}, 'BookingConfirmed.setupTimer')
      hideTimer()
    }, () => {
      showTimer()
    })
    recordFlightEvent('IDLE:CONFIRMED_DONE_ARM', { seconds: IDLE_DONE_TIMEOUT_SECONDS }, 'BookingConfirmed.mount')
    return () => {
      clearTimeout(syncT)
      hideTimer()
      // Strict Mode desmonta/remonta en la misma ruta; no pausar "done" en ese cleanup.
      if (!window.location.pathname.includes('/confirmed')) {
        setIdleDonePaused(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
      </Helmet>
      <section className={ ['section-full', 'section-flex'].join(' ') }>
        <div className={ [global.top, styles.top].join(' ') }>
          <div className={ ['logo', 'small', styles.logo].join(' ') }>
            <figure className={ ['logo-image', 'logo-image-transpais-light'].join(' ') }/>
            <div className={ styles.thanks }>
              <h1>¡GRACIAS!</h1>
            </div>
          </div>
          <div className={ styles.middle }>
            {/* Print voucher first before tickets */}
            <div>
              {voucherPrint && (
                <div
                  style={ {
                    position: 'absolute',
                    left: '-9999px',
                    top: 0,
                    width: '74mm',
                    overflow: 'hidden',
                    pointerEvents: 'none',
                  } }
                  aria-hidden
                >
                  {voucher()}
                </div>
              )}
            </div>
            {/* Container tickets */}
            <div className={ styles.details }>
              {/* <div className={ styles.tickets } ref={ ticketsArea } onScroll={ handleScroll }> */}
                { bookingTickets.map((ticket, i) => (
                  <div className={ styles.ticketContainer }> 
                    <div className={ styles.tickets } ref={ ticketsArea } onScroll={ handleScroll }>
                    <SaleTicket key={ i } ref={ (element) => {
                      ticketsRefs.current[i] = element
                    } } ticket={ ticket } payment={ payment } confirmation={ bookingPayments }
                                      printable={ true } ask={ () => {
                      // selectedTicket.current = i
                      // askPrint()
                    } } done={ printDone }/>
                    </div>
                    <div className={ styles.printButton } onClick={ () => {
                      ticketsRefs.current[i].printTicket()
                      selectedTicket.current = null
                    } }>
                      <svg className={ [styles.icon,].join(' ') }>
                        <use xlinkHref={ `#${ 'print' }` }/>
                      </svg>
                      <span>Imprimir</span>
                    </div>
                  </div>
                )) }
              {/* </div> */}
            </div>
            {/* <div className={ styles.details }>
              <div className={ styles.tickets } ref={ ticketsArea } onScroll={ handleScroll }>
                { bookingTickets.map((ticket, i) => {
                  return <Ticket key={ i } ref={(element) => {
                    ticketsRefs.current[i] = element
                  } } ticket={ ticket } payment={ payment } confirmation={ bookingPayments }
                          printable={ true } ask={ () => {
                    selectedTicket.current = i
                    askPrint()
                  } } done={ printDone }/>
                })}
              </div>
              { showScrollTop && <div className={ styles.scrollTop }>
                <IconButton
                  type="neutral"
                  icon="chevron-up"
                  onClick={ () => {
                    ticketsArea.current.scrollBy({top: -300, behavior: 'smooth'})
                    //setCurrentTicketsScroll(ticketsArea.current.scrollTop)
                  } }
                />
              </div> }
              { showScrollBottom && <div className={ styles.scrollBottom }>
                <IconButton
                  type="neutral"
                  icon="chevron-down"
                  onClick={ () => {
                    ticketsArea.current.scrollBy({top: 300, behavior: 'smooth'})
                    //setCurrentTicketsScroll(ticketsArea.current.scrollTop)
                  } }
                />
              </div> }
            </div> */}
            <div className={ styles.resume }>
              <div className={ [styles.receipt].join(' ') }>
                <h1>Tu pago</h1>
                <div className={ styles.group }>
                  <p>Fecha</p>
                  <span className={ styles.data }>{ `${ payment.date } ${ payment.time }` }</span>
                </div>
                <div className={ styles.group }>
                  <p>Referencia</p>
                  <span className={ styles.data }>{ payment.reference }</span>
                </div>
                <div className={ styles.multiGroup }>
                  <div className={ styles.group }>
                    <p>Operación</p>
                    <span className={ styles.data }>{ payment.foliocpagos }</span>
                  </div>
                  <div className={ styles.group }>
                    <p>Importe</p>
                    <span className={ styles.data }>{ currency(payment.amount) }</span>
                  </div>
                </div>
                <p className={ styles.disclaimer }>Por este pagaré me obligo incondicionalmente a pagar a la orden del
                  banco emisor el importe de este título en los términos del contrato suscrito para el uso de esta
                  tarjeta de crédito en el caso de operaciones con tarjeta de debito, expresamente reconozco y acepto
                  este recibo es el comprobante de la operación realizada, misma que se consigna en el anverso y tendrá
                  pleno valor probatorio y fuerza legal, en virtud de que lo firme personalmente y/o digite mi numero de
                  identificacion personal como firma electrónica el cual es exclusivo de mi responsabilidad manifestando
                  plena conformidad al respecto.</p>
                  <div className={styles.buttonContainer}>
                    <div className={ styles.button }>
                      {/* <Button onClick={ '' } type="neutral">Enviar por correo</Button> */}
                      <p>Enviar por correo</p>
                    </div>
                    <div className={ styles.button } onClick={ askPrintAll }>
                      {/* <Button onClick={ '' } type="neutral">Enviar por correo</Button> */}
                      <p>Imprimir todos</p>
                    </div>
                    {/* <Button onClick={ askPrintAll } type="neutral">Imprimir todos</Button> */}
                  </div>
                  {/* <Button onClick={ askPrintAll } type="neutral">Imprimir todos</Button> */}
                {/* <p></p> */}
                {/* <Button onClick={ askPrintAll } type="neutral">Imprimir todos</Button> */}
                {/* <div className={ styles.group }>
                  <Button onClick={ askPrintAll } type="neutral">Imprimir todos</Button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <footer className={ global.bottom }>
          <div>
          </div>
          <div className={ global.middle }>
            <Button onClick={ () => {
              if (wasPrinted) {
                exit()
              } else {
                askExit()
              }
            } } type="positive" right-icon="house">Listo</Button>
          </div>
          <div>
          </div>
        </footer>
      </section>
    </>
  )
}

export default BookingConfirmed
